import { QuarterSelectorType } from './quarter-selector.model';

export const QuarterLabels: Map<number, string> = new Map([
  [1, 'Q1'],
  [2, 'Q2'],
  [3, 'Q3'],
  [4, 'Q4'],
]);
export const MonthlyLabels: Map<number, string> = new Map([
  [1, 'Jan'],
  [2, 'Feb'],
  [3, 'Mar'],
  [4, 'Apr'],
  [5, 'May'],
  [6, 'Jun'],
  [7, 'Jul'],
  [8, 'Aug'],
  [9, 'Sep'],
  [10, 'Oct'],
  [11, 'Nov'],
  [12, 'Dec'],
]);

const monthMultiplier = 100;
const quarterMultiplier = 1000;

export function convertToSecretCode(year: number, value: number, type: QuarterSelectorType): number {
  const multiplier = type === QuarterSelectorType.Monthly ? monthMultiplier : quarterMultiplier;
  return Number(year) * multiplier + Number(value);
}
